// Helpers for the superuser "enter as organization admin" (impersonation) flow.
// We stash the original superuser session in sessionStorage so the user can
// return to their superuser panel without re-logging in.

const KEYS = {
  suAuth: "superuser_auth",
  suUser: "superuser_user",
  suUsername: "superuser_username",
  suFirstName: "superuser_first_name",
  suLastName: "superuser_last_name",
  suId: "superuser_id",
  suUserType: "superuser_usertype",
  suCompany: "superuser_usercompany",
  suPackage: "superuser_package",
  suSidebarConfig: "superuser_sidebar_config",
  suCompanyAdmin: "superuser_company_admin",
  suIsSuperuser: "superuser_is_superuser",
  suEmail: "superuser_email",
  impersonatedBy: "impersonated_by",
  impersonatedByName: "impersonated_by_name",
  impersonatedAsName: "impersonated_as_name",
};

export const isImpersonating = () =>
  Boolean(window.sessionStorage.getItem(KEYS.impersonatedBy));

export const getImpersonatorName = () =>
  window.sessionStorage.getItem(KEYS.impersonatedByName);

export const getImpersonatedAsName = () =>
  window.sessionStorage.getItem(KEYS.impersonatedAsName);

const SUPERUSER_FIELDS = [
  "auth",
  "username",
  "first_name",
  "last_name",
  "id",
  "usertype",
  "usercompany",
  "package",
  "sidebar_config",
  "company_admin",
  "is_superuser",
  "email",
];

    const SU_KEY_MAP = {
  auth: KEYS.suAuth,
  username: KEYS.suUsername,
  first_name: KEYS.suFirstName,
  last_name: KEYS.suLastName,
  id: KEYS.suId,
  usertype: KEYS.suUserType,
  usercompany: KEYS.suCompany,
  package: KEYS.suPackage,
  sidebar_config: KEYS.suSidebarConfig,
  company_admin: KEYS.suCompanyAdmin,
  is_superuser: KEYS.suIsSuperuser,
  email: KEYS.suEmail,
};

export function stashSuperuserSession(impersonator, targetName) {
  // Only stash if we are not already impersonating.
  if (isImpersonating()) return;
  SUPERUSER_FIELDS.forEach((field) => {
    const value = window.sessionStorage.getItem(field);
    if (value !== null && value !== undefined) {
      window.sessionStorage.setItem(SU_KEY_MAP[field], value);
    }
  });
  if (impersonator) {
    window.sessionStorage.setItem(KEYS.impersonatedBy, String(impersonator.id || ""));
    window.sessionStorage.setItem(KEYS.impersonatedByName, impersonator.username || "");
  }
  if (targetName) {
    window.sessionStorage.setItem(KEYS.impersonatedAsName, String(targetName));
  }
}

export function restoreSuperuserSession() {
  if (!isImpersonating()) return false;
  SUPERUSER_FIELDS.forEach((field) => {
    const suKey = SU_KEY_MAP[field];
    const value = window.sessionStorage.getItem(suKey);
    if (value !== null && value !== undefined) {
      window.sessionStorage.setItem(field, value);
    } else {
      window.sessionStorage.removeItem(field);
    }
  });
  // Clean up impersonation markers + stashed values.
  Object.values(KEYS).forEach((k) => window.sessionStorage.removeItem(k));
  return true;
}
